import React from "react";
import styles from "./styles.module.scss";

interface Props {
  children: React.ReactNode;
}

const Headline5: React.FC<Props> = ({
  children,
  ...rest
}) => {
  return (
    <div className={styles.headline5}>{children}</div>
  );
};

export default Headline5;
